<script>
import atshq from "../../../js/setup";
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  data() {
    return {
      apiPath: "http://diqcare-hms-api.local/",
      errors: [],
      chartdata: {
        labels: [],
        datasets: [
          {
            label: "Consultancy",
            backgroundColor: "#000",
            data: [10],
          }
        ],
      },
      options: {
        responsive: true,
        title: {
					display: true,
					text: 'Doctor activity with Patient consultancy'
				},
        maintainAspectRatio: false,
      },
    };
  },

  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      atshq
        .get("dashboard")
        .then((response) => {
          // JSON responses are automatically parsed.

          this.chartdata.labels = response.data.data.labels;
          this.chartdata.datasets[0].data = response.data.data.total_consultancy;
          // this.chartdata.datasets[1].data = response.data.data.total_consultancy;
          this.$data._chart.update();

        })
        .catch((e) => {
          this.errors.push(e);
          console.warn(e);
        });
    },
  },
  watch: {
    chartData() {
      this.$data._chart.update();
    },
  },
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}
</style>